var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.50248 4.97519C4.78492 2.15083 7.16156 0 10 0V0C12.8384 0 15.2151 2.15083 15.4975 4.97519L15.7841 7.84133C15.8016 8.01562 15.8103 8.10277 15.8207 8.18855C15.9649 9.37173 16.3717 10.5077 17.0113 11.5135C17.0576 11.5865 17.1062 11.6593 17.2034 11.8051L18.0645 13.0968C18.8508 14.2763 19.244 14.866 19.0715 15.3412C19.0388 15.4311 18.9935 15.5158 18.9368 15.5928C18.6371 16 17.9283 16 16.5108 16H3.48923C2.07168 16 1.36291 16 1.06318 15.5928C1.00651 15.5158 0.961167 15.4311 0.928544 15.3412C0.756006 14.866 1.14916 14.2763 1.93548 13.0968L2.79661 11.8051C2.89378 11.6593 2.94236 11.5865 2.98873 11.5135C3.62832 10.5077 4.03508 9.37173 4.17927 8.18855C4.18972 8.10277 4.19844 8.01562 4.21587 7.84133L4.50248 4.97519Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16C7 16.394 7.0776 16.7841 7.22836 17.1481C7.37913 17.512 7.6001 17.8427 7.87868 18.1213C8.15726 18.3999 8.48797 18.6209 8.85195 18.7716C9.21593 18.9224 9.60603 19 10 19C10.394 19 10.7841 18.9224 11.1481 18.7716C11.512 18.6209 11.8427 18.3999 12.1213 18.1213C12.3999 17.8427 12.6209 17.512 12.7716 17.1481C12.9224 16.7841 13 16.394 13 16L10 16H7Z",
    fill: "#312F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon_bell.bb33269b12355cd99ec354aa8126f1fc.svg";
export { ForwardRef as ReactComponent };